<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <div class="h5">
        Montant de garantie
      </div>
      <div class="text-gray-600 my-3">
        Vous pouvez valider votre modification et passer à la signature des
        déclarations, ou bien poursuivre vos modifications.
      </div>
    </div>
    <div class="col-12 col-md-9 mx-auto">
      <v-minus-plus
        label="null"
        :input-id="`liability-${contract.id}`"
        :list="liabilities"
        path="liabilities"
        module-name="contract"
        getter-name="get"
        setter-name="updateSubscription"
        :format="({ name }) => name"
        :getter-function="({ liabilities }) => liabilities"
        :setter-function="setLiability"
      />
    </div>
  </section>
</template>
<script>
import { PlusMinus } from '@/components/common/input';

export default {
  name: 'EditionLiability',
  components: {
    'v-minus-plus': PlusMinus,
  },
  props: {
    contract: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    liabilities() {
      if (this.contract) {
        return this.contract.liabilities || [];
      }
      return [];
    },
  },
  methods: {
    setLiability(value, path) {
      return { value, path };
    },
  },
};
</script>
<style scoped>
.custom-control {
  padding: 0;
}
.btn-block{
  width: 100%;
  height: 80px;
  color:  var(--gray-700);
  border: 2px solid var(--gray-400);
  border-radius: 8px;
}
.custom-control-label::after,
.custom-control-label::before {
  right: 0;
  left: unset;
}
</style>
